/**
 * FAQHeader Component
 * 
 * Displays the header section for FAQs.
 */

import React from 'react';

export const FAQHeader: React.FC = () => {
  return (
    <div className="text-center mb-16">
      <h2 id="faq-heading" className="text-4xl md:text-5xl font-bold mb-4">
        <span className="gradient-text">
          Rave Recovery Supplements FAQ
        </span>
      </h2>
      <p className="text-xl text-gray-300">
        Everything you need to know about <strong>RaveRemedy hydration and vitamin blends</strong>
      </p>
    </div>
  );
};